// Public support page (no auth) — used for the App Store "Support URL".
// Live at: <your-domain>/support

const CONTACT_EMAIL = "support@landclearco.com";
const CONTACT_PHONE = ""; // optional — add a phone number if you want it shown

const Item = ({ q, a }) => (
  <div className="border-b border-zinc-200 py-5">
    <h3 className="font-semibold text-zinc-900 mb-1">{q}</h3>
    <p className="text-zinc-600 leading-relaxed">{a}</p>
  </div>
);

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="support-page">
      <header className="bg-[#00341d] text-white">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-300">Land ClearCo</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-2">Support</h1>
          <p className="text-emerald-100/80 mt-2 text-sm">We&rsquo;re here to help.</p>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <section className="bg-white rounded-lg border border-zinc-200 p-6 mb-8">
          <h2 className="font-heading text-xl font-bold text-[#00341d] mb-3">Contact Us</h2>
          <p className="text-zinc-700 leading-relaxed">
            For help with the LandClearCo app, email us and we&rsquo;ll respond within one business day.
          </p>
          <p className="mt-3">
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#00341d] font-semibold underline">{CONTACT_EMAIL}</a>
            {CONTACT_PHONE ? <span className="text-zinc-700"> &nbsp;·&nbsp; {CONTACT_PHONE}</span> : null}
          </p>
        </section>

        <h2 className="font-heading text-xl font-bold text-[#00341d] mb-2">Frequently Asked Questions</h2>
        <Item
          q="How do I create a quote?"
          a="Tap New Quote, choose a customer, map the work area, and add your services. You can also tap Upload Quote to attach a PDF quote created outside the app."
        />
        <Item
          q="Why does the app need my location?"
          a="During an active job, the app shows your live position on the work-area map and alerts you before you cross a property boundary. Location is used only for these features and can be turned off in your device settings."
        />
        <Item
          q="How do payments work?"
          a="Card payments are processed securely through Stripe. You can also record cash or check payments manually."
        />
        <Item
          q="How do I delete a quote?"
          a="Open the quote and tap Delete, or use the action menu on the web dashboard. You'll be asked to confirm before it's removed."
        />
        <Item
          q="Need more help?"
          a={<>Email <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#00341d] underline">{CONTACT_EMAIL}</a> and we&rsquo;ll get back to you.</>}
        />

        <p className="text-xs text-zinc-400 mt-10 border-t border-zinc-200 pt-6">
          &copy; {new Date().getFullYear()} Land ClearCo, LLC. All rights reserved.
        </p>
      </main>
    </div>
  );
};

export default SupportPage;
